// extracted by mini-css-extract-plugin
export default {"AddEquipment":"AddEquipment_AddEquipment__SKj0t"};